import React from "react";
import { DropdownButton, Button, Dropdown } from "react-bootstrap";
import { SegmentedControlWithoutStyles } from "segmented-control";
import "./BotFilterPanel.scss";
//import { TimeFrames, Frequencies, BaseCoins } from "../../../Const";



const BotFilterPanel = (props) => {
  const {
    baseCoin,
    setBaseCoin,
    sort,
    setSort,
    orderBy,
    setOrderBy,
    strategy,
    setStrategy,
    t
  } = props;
  const Sorts = { apy: "APY", name: t("NAME") , created_at:t("DATE"),performance:t("PERFORMANCE"),profit:t("RETURN")};
  const OrderBy = { desc: "DESC", asc: "ASC" };
  const sortOptions = Object.keys(Sorts).map((el) => {
    return (
      <Dropdown.Item key={el} eventKey={el} className="text-left">
        {Sorts[el]}
      </Dropdown.Item>
    );
  });
  const orderByOptions = Object.keys(OrderBy).map((el, id) => {
    return (
      <Dropdown.Item key={el} eventKey={el} className="text-left">
        {OrderBy[el]}
      </Dropdown.Item>
    );
  });

  return (
    <div className="filter-panel-marketplace" >
      <div className="flex ml-2">
        {/* <label><i class="fas fa-sort"></i></label> */}
        <DropdownButton
          title={Sorts[sort]}
          className="select-btn ml-2"
          onSelect={(e) => setSort(e)}
        >
          {sortOptions}
        </DropdownButton>
      </div>
      
      <div className="flex">
      {/* <label>Order By</label> */}
      <DropdownButton
        title={OrderBy[orderBy]}
        className="select-btn ml-2"
        onSelect={(e) => setOrderBy(e)}
      >
        {orderByOptions}
      </DropdownButton>
      </div>
      {/* <div className="flex">
      
      <DropdownButton
        title={baseCoin}
        className="select-btn ml-2"
        onSelect={(e) => setBaseCoin(e)}
      >
        {coinItems}
      </DropdownButton>
      </div> */}
     
    </div>
  );
};

export default BotFilterPanel;
